import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Rx'
import { alertError, alertSuccess } from 'store/ducks/alert'
import { getLandingPage, upsertLandingPage } from '../services/landingPage'
import { intl } from 'i18n/index'

// Actions
export const FETCH_LANDING_PAGE_REQUEST = 'landingPage/FETCH_LANDING_PAGE_REQUEST'
export const FETCH_LANDING_PAGE_SUCCESS = 'landingPage/FETCH_LANDING_PAGE_SUCCESS'
export const FETCH_LANDING_PAGE_FAILURE = 'landingPage/FETCH_LANDING_PAGE_FAILURE'

export const UPSERT_LANDING_PAGE_REQUEST = 'landingPage/UPSERT_LANDING_PAGE_REQUEST'
export const UPSERT_LANDING_PAGE_SUCCESS = 'landingPage/UPSERT_LANDING_PAGE_SUCCESS'
export const UPSERT_LANDING_PAGE_FAILURE = 'landingPage/UPSERT_LANDING_PAGE_FAILURE'

// Reducer
const INITIAL_STATE = {
  data: null,
  loading: false,
  error: null,
  saving: false,
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case FETCH_LANDING_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case FETCH_LANDING_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      }

    case FETCH_LANDING_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case UPSERT_LANDING_PAGE_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
      }

    case UPSERT_LANDING_PAGE_SUCCESS:
      return {
        ...state,
        saving: false,
        data: action.payload,
        error: null,
      }

    case UPSERT_LANDING_PAGE_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error,
      }

    default:
      return state
  }
}

// Action Creators
export const fetchLandingPageRequest = (landingPageId) => ({
  type: FETCH_LANDING_PAGE_REQUEST,
  landingPageId,
})

export const fetchLandingPageSuccess = (payload) => ({
  type: FETCH_LANDING_PAGE_SUCCESS,
  payload,
})

export const fetchLandingPageFailure = (error) => ({
  type: FETCH_LANDING_PAGE_FAILURE,
  error,
})

export const upsertLandingPageRequest = (payload) => ({
  type: UPSERT_LANDING_PAGE_REQUEST,
  payload,
})

export const upsertLandingPageSuccess = (payload) => ({
  type: UPSERT_LANDING_PAGE_SUCCESS,
  payload,
})

export const upsertLandingPageFailure = (error) => ({
  type: UPSERT_LANDING_PAGE_FAILURE,
  error,
})

// Epics
export function fetchLandingPageEpic(action$) {
  return action$.ofType(FETCH_LANDING_PAGE_REQUEST).mergeMap((action) =>
    Observable.ajax(getLandingPage(action.landingPageId))
      .map((result) => fetchLandingPageSuccess(result.response))
      .catch((error) =>
        Observable.of(
          fetchLandingPageFailure(error),
          alertError(intl.formatMessage({ id: 'ducks.alert.errorDefault' })),
        ),
      ),
  )
}

export function upsertLandingPageEpic(action$) {
  return action$.ofType(UPSERT_LANDING_PAGE_REQUEST).mergeMap((action) =>
    Observable.ajax(upsertLandingPage(action.payload))
      .mergeMap((result) =>
        Observable.of(
          upsertLandingPageSuccess(result.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.landingPage.upsert.success' })),
        ),
      )
      .catch((error) =>
        Observable.of(
          upsertLandingPageFailure(error),
          alertError(intl.formatMessage({ id: 'ducks.landingPage.upsert.error' })),
        ),
      ),
  )
}

export const epic = combineEpics(fetchLandingPageEpic, upsertLandingPageEpic)
